<template>
  <div class="service-error-wrap">
    <img :src="errorImage" alt="에러 페이지 아이콘" class="img-error02" />
    <p class="service-error-tit">서비스 이용에<br />불편을 드려 죄송합니다.</p>
    <p class="service-error-text">찾으시는 페이지가 없거나 오류가 발생하였습니다.<br>입력하신 주소가 정확한지 다시한번 확인해 주세요.</p>
    <p class="service-error-text">관련 문의사항은 고객센터 1599-3709로 문의하시면 친절하게 안내해드리겠습니다.</p>
    <div class="service-error-btn">
      <ul>
        <li>
          <a href="/" class="round-btn-purple-f">홈으로</a>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  name: 'NotFound',
  data () {
    return {
      errorImage: require('../../assets/images/img-error02.png')
    }
  }
}
</script>

<style scoped>
  *{margin: 0; padding: 0; word-break: break-all; word-wrap: break-word; -webkit-box-sizing: border-box; box-sizing: border-box;}
  ul, ol, li{list-style: none;}
  a{text-decoration: none; font-weight: 400;}
  a:link, a:visited{text-decoration: none;}
  button{background: transparent; border: 0 none; cursor: pointer;}
  img{border: 0 none; vertical-align: middle;}
  html, body{width: 100%; height: 100%;}
  body{font-family: 'NotoSans',sans-serif; width: 100%; overflow-x: hidden; word-break: keep-all; word-wrap: break-word; background-color: #1b1b1b;}
  /* scope */
  .service-error-wrap{padding: 70px 20px 125px; text-align: center;}
  .service-error-wrap .img-error02{display: block; width: 92px; margin: 0 auto 40px;}
  .service-error-tit{font-size: 20px; line-height: 28px; color: #fff; letter-spacing: -0.33px;}
  .service-error-text{margin-top: 20px; font-size: 14px; line-height: 24px; color: #a5a5a5; letter-spacing: -0.27px;}
  .service-error-btn{position: fixed; bottom: 20px; left: 0; width: 100%; padding: 0 20px;}
  .round-btn-purple-f{display: block; width: 100%; height: 45px; border: 1px #1351f9 solid; border-radius: 100px; background-color: #1351f9; font-size: 16px; line-height: 43px; color: #fff; font-weight: 700; letter-spacing: -0.3px; text-align: center;}

  @media all and (max-width:340px){
    .service-error-tit{
      font-size: 18px;
    }
    .service-error-text{
      font-size: 12px;
    }
  }
</style>
